<div class="d-flex justify-content-between align-items-center mb-3">
  <h1 class="page-title mb-0">Package List</h1>
</div>

<form [formGroup]="certificateReportForm">
  <!-- Compact Filter Panel -->
  <div class="content-card mb-3">
    <div class="card-section-header d-flex justify-content-between align-items-center py-2 px-3">
      <h6 class="mb-0"><i class="fa fa-filter me-2"></i>Filters</h6>
      <button type="button" class="btn btn-sm btn-link text-decoration-none" (click)="onReset()">
        <i class="fa fa-rotate-right me-1"></i>Reset
      </button>
    </div>
    <div class="card-section-body py-3 px-3">
      <!-- Row 1: 4 columns -->
      <div class="row g-2 mb-2">
        <div class="col-md-3">
          <label for="packageNumber" class="form-label small mb-1">Package Number</label>
          <input type="text" id="packageNumber" formControlName="packageNumber" class="form-control form-control-sm"
            placeholder="Enter package #"
            [ngClass]="{ 'is-invalid': submitted && f.packageNumber.errors }" />
        </div>
        <div class="col-md-3">
          <label for="chasisNumber" class="form-label small mb-1">Chasis Number</label>
          <input type="text" id="chasisNumber" formControlName="chasisNumber" class="form-control form-control-sm"
            placeholder="Enter chasis #"
            [ngClass]="{ 'is-invalid': submitted && f.chasisNumber.errors }" />
        </div>
        <div class="col-md-3">
          <label for="policyNumber" class="form-label small mb-1">Policy Number</label>
          <input type="text" id="policyNumber" formControlName="policyNumber" class="form-control form-control-sm"
            placeholder="Enter policy #"
            [ngClass]="{ 'is-invalid': submitted && f.policyNumber.errors }" />
        </div>
        <div class="col-md-3">
          <label for="userName" class="form-label small mb-1">Executive Dealer Name</label>
          <input type="text" id="userName" formControlName="userName" class="form-control form-control-sm"
            placeholder="Enter dealer name"
            [ngClass]="{ 'is-invalid': submitted && f.userName.errors }" />
        </div>
      </div>
      <!-- Row 2: 4 columns -->
      <div class="row g-2 mb-2">
        <div class="col-md-3">
          <label for="firstName" class="form-label small mb-1">Client First Name</label>
          <input type="text" id="firstName" formControlName="firstName" class="form-control form-control-sm"
            placeholder="First name"
            [ngClass]="{ 'is-invalid': submitted && f.firstName.errors }" />
        </div>
        <div class="col-md-3">
          <label for="lastName" class="form-label small mb-1">Client Last Name</label>
          <input type="text" id="lastName" formControlName="lastName" class="form-control form-control-sm"
            placeholder="Last name"
            [ngClass]="{ 'is-invalid': submitted && f.lastName.errors }" />
        </div>
        <div class="col-md-3">
          <label for="issueDateFrom" class="form-label small mb-1">Issue Date From</label>
          <div class="input-group input-group-sm">
            <input class="form-control" formControlName="issueDateFrom" ngbDatepicker #d="ngbDatepicker"
              placeholder="yyyy-mm-dd"
              [ngClass]="{ 'is-invalid': submitted && f.issueDateFrom.errors }">
            <button class="btn btn-outline-secondary fa fa-calendar" (click)="d.toggle()" type="button"
              aria-label="Open date picker"></button>
          </div>
          <div *ngIf="submitted && f.issueDateFrom.errors" class="invalid-feedback d-block" style="font-size: 0.75rem">
            <span *ngIf="f.issueDateFrom.errors.required">Required</span>
          </div>
        </div>
        <div class="col-md-3">
          <label for="issueDateTo" class="form-label small mb-1">Issue Date To</label>
          <div class="input-group input-group-sm">
            <input class="form-control" formControlName="issueDateTo" ngbDatepicker #issueDateTo="ngbDatepicker"
              placeholder="yyyy-mm-dd"
              [ngClass]="{ 'is-invalid': submitted && f.issueDateTo.errors }">
            <button class="btn btn-outline-secondary fa fa-calendar" (click)="issueDateTo.toggle()" type="button"
              aria-label="Open date picker"></button>
          </div>
          <div *ngIf="submitted && f.issueDateTo.errors" class="invalid-feedback d-block" style="font-size: 0.75rem">
            <span *ngIf="f.issueDateTo.errors.required">Required</span>
          </div>
        </div>
      </div>
      <!-- Search Button Row -->
      <div class="d-flex justify-content-end pt-1">
        <button (click)="onSubmit()" [disabled]="loading" class="btn btn-primary btn-sm">
          <span *ngIf="loading" class="spinner-border spinner-border-sm me-1"></span>
          <i *ngIf="!loading" class="fa fa-search me-1"></i>
          Search
        </button>
      </div>
    </div>
  </div>
  <div class="package-summary d-flex flex-wrap align-items-center gap-2 my-2" *ngIf="packages">
    <span class="badge bg-dark">Total: {{summary.total}}</span>
    <span class="summary-sep">|</span>
    <button type="button" class="btn btn-sm summary-chip" [ngClass]="selectedTypes.has('New') ? 'btn-primary' : 'btn-outline-primary'" (click)="toggleFilter(selectedTypes, 'New')">New: {{summary.newCount}}</button>
    <button type="button" class="btn btn-sm summary-chip" [ngClass]="selectedTypes.has('Renewal') ? 'btn-primary' : 'btn-outline-primary'" (click)="toggleFilter(selectedTypes, 'Renewal')">Renewal: {{summary.renewalCount}}</button>
    <span class="summary-sep">|</span>
    <button type="button" class="btn btn-sm summary-chip" *ngFor="let s of summary.statuses" [ngClass]="selectedStatuses.has(s.status) ? 'btn-primary' : 'btn-outline-primary'" (click)="toggleFilter(selectedStatuses, s.status)">{{s.status}}: {{s.count}}</button>
    <ng-container *ngIf="(user.role == 'admin' || user.role == 'employee') && summary.enteredBy.length">
      <span class="summary-sep">|</span>
      <span class="small text-muted">Entered by:</span>
      <button type="button" class="btn btn-sm summary-chip" *ngFor="let e of summary.enteredBy" [ngClass]="selectedEnteredBy.has(e.name) ? 'btn-primary' : 'btn-outline-primary'" (click)="toggleFilter(selectedEnteredBy, e.name)">{{e.name}}: {{e.count}}</button>
    </ng-container>
  </div>
  <div class="table-responsive package-list-table-wrap">
    <table class="table table-striped table-hover" aria-label="Package list">
      <thead>
        <tr>
          <th>Package Number</th>
          <th *ngIf="user.role == 'admin' || user.role == 'employee'">Dealer Name</th>
          <th>Owner Name</th>
          <th>Certificate Number</th>
          <th>Bike Model</th>
          <th>Policy Number</th>
          <th>Policy Type</th>
          <th>Bike Issue Date</th>
          <th>Package Status</th>
          <th *ngIf="user.role == 'admin' || user.role == 'employee'">Entered By</th>
          <th class="th-actions">Action</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let package of visiblePackages">
          <td>{{package.packageNumber}}</td>
          <td *ngIf="user.role == 'admin' || user.role == 'employee'">{{package.dealerName}}</td>
          <td>{{package.firstName + " " + (package.lastName?package.lastName:"")}}</td>
          <td>{{package.certificateNumber}}</td>
          <td>{{package.model}}</td>
          <td>{{package.insurancePolicyNumber}}</td>
          <td>{{package.type == 'Old'? "Renewal":"New"}}</td>
          <td>{{package.issueDateString}}</td>
          <td>{{package.packageStatus}}</td>
          <td *ngIf="user.role == 'admin' || user.role == 'employee'">{{package.userNameProcessed}}</td>
          <td class="td-actions">

            <div class="dropdown" *ngIf="isAnyActionAvailable(package, user)">
              <button class="btn btn-sm dropdown-toggle"
                [ngClass]="{'btn-secondary': ['Submitted','Certificate Generated'].includes(package.packageStatus) && ['admin','employee'].includes(user.role), 'btn-primary': !(['Submitted','Certificate Generated'].includes(package.packageStatus) && ['admin','employee'].includes(user.role))}"
                type="button" [attr.id]="'dropdownActionButton' + package.packageNumber" data-bs-toggle="dropdown"
                data-bs-boundary="viewport" 
                (shown.bs.dropdown)="onDropdownShow($event, package.packageNumber)"
                (hidden.bs.dropdown)="onDropdownHide($event, package.packageNumber)"
                aria-haspopup="true" aria-expanded="false">
                Actions
              </button>
              <div class="dropdown-menu dropdown-menu-end package-actions-menu" 
                   [attr.aria-labelledby]="'dropdownActionButton' + package.packageNumber">

                <a class="dropdown-item" (click)="processPackage(package)"
                  *ngIf="package.packageStatus== 'Submitted' && ((user.role == 'admin' || user.role == 'employee') || (user.specialRoleAccess && user.specialRoleAccess.includes('CanGenerateOldPolicyPackage') && package.type=='Old')) "
                  [attr.disabled]="package.packageStatus!= 'Submitted' ? true : null">
                  <i class="fa fa-cog"></i> Generate Package
                </a>
                <a class="dropdown-item" (click)="preparePackage(package)"
                  *ngIf="((package.packageStatus =='Certificate Generated' && user.role == 'employee')) || (['Certificate Generated','Print Ready','Endorsement Requested','Cancelation Requested'].includes(package.packageStatus) && user.role == 'admin' && (package.certificateNumber) )">
                  <i class="fa fa-arrow-down"></i> Prepare Package
                </a>
                <a class="dropdown-item" (click)="viewPackage(package)"
                  *ngIf="((user.role == 'admin' || user.role == 'employee'))">
                  <i class="fa fa-eye"></i> View
                </a>
                <a class="dropdown-item text-danger" (click)="selectCancelPackage(package)" data-bs-toggle="modal"
                  data-bs-target="#myModal"
                  *ngIf="['Certificate Generated','Submitted','Print Ready'].includes(package.packageStatus) && (user.role == 'admin' || user.role == 'employee')">
                  <i class="fa fa-times-circle"></i> Request Cancel
                </a>
                <a class="dropdown-item text-info" (click)="selectCancelPackage(package)" data-bs-toggle="modal"
                  data-bs-target="#myEndorseRequestModal"
                  *ngIf="['Certificate Generated','Print Ready'].includes(package.packageStatus) && (user.role == 'admin' || user.role == 'employee')">
                  <i class="fa fa-pen-nib"></i> Request Endorsement
                </a>
                <a class="dropdown-item" (click)="selectCancelPackage(package)" data-bs-toggle="modal"
                  data-bs-target="#showCommentHistoryModel"
                  *ngIf="(package && package.requestHistory && package.requestHistory.length > 0) && (user.role == 'admin' || user.role == 'employee')">
                  <i class="fa fa-upload"></i> Comment History
                </a>
                <div class="dropdown-divider" *ngIf="user.role == 'admin'"></div>
                <a class="dropdown-item" (click)="selectCancelPackage(package)" data-bs-toggle="modal"
                data-bs-target="#myPdfEndorseModel"
                *ngIf="['Endorsement Requested'].includes(package.packageStatus) && (user.role == 'admin' )">
                <i class="fa fa-pen-nib"></i> Endorse
              </a>
                <a class="dropdown-item" (click)="uploadPackage(package)" data-bs-toggle="modal"
                  data-bs-target="#myPdfUploadModel"
                  *ngIf="['Certificate Generated','Submitted','Print Ready'].includes(package.packageStatus) && (user.role == 'admin' )">
                  <i class="fa fa-upload"></i> Upload
                </a>
                <a class="dropdown-item text-danger" (click)="selectCancelPackage(package)" data-bs-toggle="modal"
                  data-bs-target="#cancelModel"
                  *ngIf="['Cancelation Requested'].includes(package.packageStatus) && (user.role == 'admin')">
                  <i class="fa fa-times-circle"></i> Cancel
                </a>
                <a class="dropdown-item" (click)="downloadPackage(package)"
                  *ngIf="(package.packageStatus== 'Print Ready')||(['Cancelation Requested','Endorsement Requested'].includes(package.packageStatus) && (user.role == 'admin') && (package.certificateNumber))">
                  <i class="fa fa-print"></i> Print
                </a>
              </div>
            </div>

          </td>
        </tr>
        <tr *ngIf="loading">
          <td [attr.colspan]="(user.role == 'admin' || user.role == 'employee') ? 11 : 9" class="text-center">
            <span class="spinner-border spinner-border-lg align-center"></span>
          </td>
        </tr>
        <tr *ngIf="!loading && visiblePackages.length === 0">
          <td [attr.colspan]="(user.role == 'admin' || user.role == 'employee') ? 11 : 9" class="text-center">
            No records found
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</form>

<!-- Cancel Request Modal -->
<div class="modal" id="myModal" role="dialog" aria-labelledby="myModalTitle" aria-modal="true">
  <div class="modal-dialog">
    <div class="modal-content">

      <!-- Modal Header -->
      <div class="modal-header">
        <h4 class="modal-title" id="myModalTitle">Are you sure?</h4>
      </div>

      <!-- Modal body -->
      <div class="modal-body">
        <app-show-request-history></app-show-request-history>
        <form [formGroup]="cancelPackageRequestForm">

          <div class="mb-3">
            <label for="cancelReason" class="form-label">Reason(Add Details for future reference):</label>
            <textarea formControlName="cancelReason" class="form-control"
              [ngClass]="{ 'is-invalid': cancelRequestF.cancelReason.errors }"></textarea>
            <div *ngIf="cancelRequestF.cancelReason?.errors" class="invalid-feedback">
              <div *ngIf="cancelRequestF.cancelReason?.errors.required">Cancel Reason is required</div>
            </div>
          </div>

        </form>
      </div>

      <!-- Modal footer -->
      <div class="modal-footer">
        <button type="button" #closeRequestCancelModalBtn class="btn btn-primary btn-sm me-1"
          data-bs-dismiss="modal" aria-label="Close">Close</button>
        <button (click)="requestCancelPackage()" class="btn btn-sm btn-danger me-1"
          *ngIf="!(canceledPackageSelect && canceledPackageSelect.packageStatus == 'Cancelation Requested')">
          <span *ngIf="isDeleting" class="spinner-border spinner-border-sm"></span>
          <span *ngIf="!isDeleting">Yes</span>
        </button>

      </div>

    </div>
  </div>
</div>

<!-- PDF Upload Modal -->
<div class="modal" id="myPdfUploadModel" role="dialog" aria-labelledby="myPdfUploadModelTitle" aria-modal="true">
  <div class="modal-dialog">
    <div class="modal-content">

      <!-- Modal Header -->
      <div class="modal-header">
        <h4 class="modal-title" id="myPdfUploadModelTitle">Upload Endorse policy PDF</h4>
      </div>
      <div class="modal-body" *ngIf=modelLoading>
        <div class="spinner-border text-info" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>
      <!-- Modal body -->
      <div class="modal-body" *ngIf=!modelLoading>
        <app-show-request-history></app-show-request-history>

        <!-- show bootstrap message informing completion of Upload -->
        <div *ngIf="uploadSuccess" class="alert alert-success" role="alert">
          <strong>Policy PDF uploaded successfully!!! </strong>
        </div>
        <div *ngIf="uploadSuccess" class="alert alert-success" role="alert">
          <strong>Review printed certificate by clicking on Prepare Package!!! </strong>
        </div>

        <div class="mb-3 col">
          <label for="policyPdf" class="form-label">Policy PDF file</label>
          <input type="file" (change)="onPolicyPdfSelected($event)" accept="application/pdf" class="form-control" />
        </div>
      </div>

      <!-- Modal footer -->
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary btn-sm me-1" data-bs-dismiss="modal" aria-label="Close">Close</button>
      </div>

    </div>
  </div>
</div>

<!-- Comment History Modal -->
<div class="modal" id="showCommentHistoryModel" role="dialog" aria-labelledby="showCommentHistoryModelTitle" aria-modal="true">
  <div class="modal-dialog">
    <div class="modal-content">

      <!-- Modal Header -->
      <div class="modal-header">
        <h4 class="modal-title" id="showCommentHistoryModelTitle">Comments</h4>
      </div>
      <div class="modal-body">
        <app-show-request-history></app-show-request-history>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary btn-sm me-1" data-bs-dismiss="modal" aria-label="Close">Close</button>
      </div>
    </div>
  </div>
</div>

<!-- Cancel Modal -->
<div class="modal" id="cancelModel" role="dialog" aria-labelledby="cancelModelTitle" aria-modal="true">
  <div class="modal-dialog">
    <div class="modal-content">

      <!-- Modal Header -->
      <div class="modal-header">
        <h4 class="modal-title" id="cancelModelTitle">Cancel</h4>
      </div>
      <div class="modal-body">
        <app-show-request-history></app-show-request-history>
        <form [formGroup]="cancelPackageRequestForm">
          <div class="container">
            <div class="row" *ngIf="canceledPackageSelect && canceledPackageSelect.certificateNumber">
              <div class="col">
                <!-- Bootstrap toggle -->
                <div class="form-check form-switch">
                  <input class="form-check-input" type="checkbox" id="packageAmountReversedToggle"
                    formControlName="packageAmountReversed">
                  <label class="form-check-label" for="packageAmountReversedToggle">Has Insurance Company Reversed
                    Policy Amount?</label>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <label for="cancelReason" class="form-label">Comments:</label>
              <textarea formControlName="cancelReason" class="form-control"
                [ngClass]="{ 'is-invalid': cancelRequestF.cancelReason.errors }"></textarea>
              <div *ngIf="cancelRequestF.cancelReason?.errors" class="invalid-feedback">
                <div *ngIf="cancelRequestF.cancelReason?.errors.required">Cancel Reason is required</div>
              </div>
            </div>
          </div>
        </form>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary btn-sm me-1" data-bs-dismiss="modal" aria-label="Close">Close</button>
        <button (click)="cancelPackage()" class="btn btn-sm btn-danger me-1"
          *ngIf="!(canceledPackageSelect && canceledPackageSelect.packageStatus == 'Cancelled')">
          <span *ngIf="isDeleting" class="spinner-border spinner-border-sm"></span>
          <span *ngIf="!isDeleting">Cancel</span>
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Endorsement Request Modal -->
<div class="modal" id="myEndorseRequestModal" role="dialog" aria-labelledby="myEndorseRequestModalTitle" aria-modal="true">
  <div class="modal-dialog">
    <div class="modal-content">

      <!-- Modal Header -->
      <div class="modal-header">
        <h4 class="modal-title" id="myEndorseRequestModalTitle">Endorsement</h4>
      </div>

      <!-- Modal body -->
      <div class="modal-body">
        <app-show-request-history></app-show-request-history>
        <form [formGroup]="cancelPackageRequestForm">

          <div class="mb-3">
            <label for="cancelReason" class="form-label">Endorsement Details(add information of all values modified):</label>
            <textarea formControlName="cancelReason" class="form-control"
              [ngClass]="{ 'is-invalid': cancelRequestF.cancelReason.errors }"></textarea>
            <div *ngIf="cancelRequestF.cancelReason?.errors" class="invalid-feedback">
              <div *ngIf="cancelRequestF.cancelReason?.errors.required">Endorsement Details is required</div>
            </div>
          </div>

        </form>
      </div>

      <!-- Modal footer -->
      <div class="modal-footer">
        <button type="button" class="btn btn-primary btn-sm me-1"
          data-bs-dismiss="modal" aria-label="Close">Close</button>
        <button (click)="requestEndorsePackage()" class="btn btn-sm btn-danger me-1"
          *ngIf="!(canceledPackageSelect && canceledPackageSelect.packageStatus == 'Endorsement Requested')">
          <span *ngIf="isDeleting" class="spinner-border spinner-border-sm"></span>
          <span *ngIf="!isDeleting">Request</span>
        </button>

      </div>

    </div>
  </div>
</div>

<!-- Endorsement Process Modal -->
<div class="modal" id="myPdfEndorseModel" role="dialog" aria-labelledby="myPdfEndorseModelTitle" aria-modal="true">
  <div class="modal-dialog">
    <div class="modal-content">

      <!-- Modal Header -->
      <div class="modal-header">
        <h4 class="modal-title" id="myPdfEndorseModelTitle">Endorsement</h4>
      </div>
      <div class="modal-body" *ngIf=modelLoading>
        <div class="spinner-border text-info" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>
      <!-- Modal body -->
      <div class="modal-body" *ngIf=!modelLoading>
        <app-show-request-history></app-show-request-history>
        <form [formGroup]="cancelPackageRequestForm">
          <div class="container">
            <h4>Step 1: Endorse the Certificate</h4>
            <div class="row" *ngIf="canceledPackageSelect && canceledPackageSelect.certificateNumber">
              <div class="col">
                <!-- Bootstrap toggle -->
                <div class="form-check form-switch">
                  <input class="form-check-input" type="checkbox" id="packageAmountReversedToggle"
                    formControlName="packageAmountReversed">
                  <label class="form-check-label" for="packageAmountReversedToggle">Is certificate endorsed successfully?</label>
                </div>
              </div>
            </div>

            <!-- show bootstrap message informing completion of Upload -->
            <div *ngIf="uploadSuccess" class="alert alert-success" role="alert">
              <strong>Endorsement Completed!!! Modified policy PDF has been attached to package. Close this window by clicking on close button</strong>
            </div>

            <h4 *ngIf="cancelPackageRequestForm.get('packageAmountReversed').value">Step 2: Upload the Endorsed Policy</h4>
            <div class="mb-3" *ngIf="cancelPackageRequestForm.get('packageAmountReversed').value">
              <label for="policyPdf" class="form-label">Upload Endorsed Policy PDF file</label>
              <input type="file" (change)="onPolicyPdfSelected($event)" accept="application/pdf" class="form-control" />
            </div>

            <div class="mb-3">
              <label for="cancelReason" class="form-label">Comments:</label>
              <textarea formControlName="cancelReason" class="form-control"
                [ngClass]="{ 'is-invalid': cancelRequestF.cancelReason.errors }"></textarea>
              <div *ngIf="cancelRequestF.cancelReason?.errors" class="invalid-feedback">
                <div *ngIf="cancelRequestF.cancelReason?.errors.required">Endorsement comment is required</div>
              </div>
            </div>
          </div>
        </form>
      </div>

      <!-- Modal footer -->
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary btn-sm me-1" data-bs-dismiss="modal" aria-label="Close">Close</button>
        <button (click)="endorsePackage()" class="btn btn-sm btn-danger me-1"
          *ngIf="(canceledPackageSelect && canceledPackageSelect.packageStatus == 'Endorsement Requested')">
          <span *ngIf="isDeleting" class="spinner-border spinner-border-sm"></span>
          <span *ngIf="!isDeleting">Endorsement Completed</span>
        </button>
      </div>

    </div>
  </div>
</div>
